// Notification preferences on their own screen (opened from Profile → Account
// actions), so the long per-topic list doesn't stretch the profile page.
import { useNavigate } from 'react-router-dom';
import NotificationPreferencesPanel from '../components/notifications/NotificationPreferencesPanel';

export default function NotificationPreferencesPage() {
  const navigate = useNavigate();
  return (
    <div
      className="min-h-screen bg-[#F9FAFB] pb-nav text-[#2B3A67]"
      style={{ fontFamily: "'Outfit', sans-serif" }}
    >
      <header className="sticky top-0 z-30 bg-[#F9FAFB]/90 backdrop-blur-md border-b border-gray-100 pt-safe">
        <div className="flex items-center gap-3 px-6 py-4">
          <button
            onClick={() => navigate('/profile')}
            className="w-10 h-10 bg-white rounded-full flex items-center justify-center shadow-sm border border-gray-100"
            aria-label="Back to profile"
            data-testid="notification-prefs-back"
          >
            <i className="ph-bold ph-arrow-left text-xl" />
          </button>
          <h1 className="font-extrabold text-xl">Notification preferences</h1>
        </div>
      </header>
      <main className="px-6 pt-6">
        <NotificationPreferencesPanel showHeading={false} />
      </main>
    </div>
  );
}
